export class ColorUtility {
    public static rgbArrayToObject(rgb: number[]): RgbColor {
        return {
            r: rgb[0],
            g: rgb[1],
            b: rgb[2]
        }
    }

    public static rgbObjectToArray(rgb: RgbColor): number[] {
        return [rgb.r, rgb.g, rgb.b];
    }

    public static getRgbGradient(rgbStart: RgbColor, rgbEnd: RgbColor, stops: number) {
        const nullColor: RgbColor = { r: null, g: null, b: null };
        const gradient: RgbColor[] = Array.from({ length: stops }).map(() => nullColor);
        const l = 0;
        const r = stops - 1;
        gradient[l] = rgbStart;
        gradient[r] = rgbEnd;

        this.divideAndConquer(gradient, l, r);

        return gradient;
    }


    public static colorBlend(c1Weight: number, c1: RgbColor, c2: RgbColor) {
        /*c1Weight should be a percentage represented as a decimal. 
          For example, if you want to mix black and white in a 40/60 blend, 
          c1Weight = 0.4
        */
        const w1 = c1Weight;
        const w2 = 1 - c1Weight;

        return {
            r: (c1.r * w1) + (c2.r * w2),
            g: (c1.g * w1) + (c2.g * w2),
            b: (c1.b * w1) + (c2.b * w2)
        }
    }

    public static getRgbHoverColor(rgb: number[], hoverBrightness: number): number[] {
        const hoverRgb = rgb.map(value => value + hoverBrightness <= 255 ? value + hoverBrightness : 255);
        return hoverRgb;
    }

    public static rgbObjectToString(rgb: RgbColor): string {
        return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
    }

    public static rgbArrayToString(rgb: number[]): string {
        return this.rgbObjectToString(this.rgbArrayToObject(rgb))
    }

    private static divideAndConquer(gradient: RgbColor[], l: number, r: number) {
        const m = Math.floor(l + (r - l) * 0.5);
        if (l < r - 1) {
            this.getRgbMidpoint(gradient, l, m, r);

            this.divideAndConquer(gradient, l, m);
            this.divideAndConquer(gradient, m, r)
        }
    }

    private static getRgbMidpoint(gradient: RgbColor[], l: number, m: number, r: number) {
        const rgbLeft = gradient[l];
        const rgbRight = gradient[r];
        gradient[m] = this.colorBlend(0.5, rgbLeft, rgbRight);
    }
}


export interface RgbColor {
    r: number,
    g: number,
    b: number
}

